module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "bt",
    attrs: {
      "id": "d6e1694"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("THE")])]), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_c('b', [_vm._v("EVERYTHING")])]), _c('sub', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("®")])])]), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_c('b', [_vm._v("SELF-ESTEEM")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("BOOK")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1c",
    attrs: {
      "id": "d6e1804"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("Boost your confidence, achieve inner"), _c('br'), _vm._v(" strength, and learn to love yourself")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2c",
    attrs: {
      "id": "d6e1884"
    }
  }, [_c('b', [_vm._v("Robert M. Sherfield, Ph.D.")]), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "logo",
      "id": "d14e190",
      "src": "images/logo.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f796874","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sher_9781440522697_epub_c1_r1.vue
// module id = 60
// module chunks = 0